import React, { useState } from 'react';
import DialogWindow from '../../../Elements/DialogWindow/DialogWindow';
import DialogCloseButton from '../../../Elements/DialogWindow/DialogCloseButton';
import FigmaButton from '../../../Elements/FigmaButton';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';

function DialogWindowDemoComponent() {
  const [isOpen, setIsOpen] = useState(false);
  const [isDone, setIsDone] = useState(false);

  function open() {
    setIsDone(false);
    setIsOpen(true);
  }

  function renderButtons() {
    if (isDone) {
      return <DialogCloseButton onClick={() => setIsOpen(false)} />;
    }
    return (
      <>
        <DialogCloseButton
          label='Cancel'
          onClick={() => setIsOpen(false)}
        />
        <FigmaButton
          label='Run'
          type={ButtonTypeEnum.NormalNormal}
          color={ButtonColorsEnum.Primary}
          onClick={() => setIsDone(true)}
        />
      </>
    );
  }

  return (
    <div>
      <div className='dsg-row'>
        <button
          type='button'
          className='btn primary'
          onClick={open}
        >
          <i className='fa-solid fa-play' /> Open dialog window
        </button>
      </div>
      {isOpen && (
        <DialogWindow
          title='Run the demo task'
          eyebrow='Demo project'
          iconName='fa-solid fa-play'
          warningText={isDone ? null : 'Nothing is sent anywhere.'}
          buttons={renderButtons()}
          onClose={() => setIsOpen(false)}
        >
          <p>{isDone ? 'The demo task is done.' : 'The demo task will tidy up 3 in-memory items.'}</p>
        </DialogWindow>
      )}
    </div>
  );
}

export const dialogWindowDemo = {
  id: 'dialog-window',
  title: 'Dialog window',
  category: 'Overlays & Editing',
  importPath: 'Elements/DialogWindow/DialogWindow',
  notes: [
    'A window with a body (the children) and a footer: an error, or else a warning, on the left, the buttons on the right. Built on the same window as the edit wizard, so it looks the same.',
    'It closes from its X or Esc without asking, which suits confirmations and results. A window that edits data sets hasUnsavedChanges while something typed would be lost: the X and Esc then ask first, as the edit wizard does. Its sections are FormSection.',
    'DialogCloseButton is the footer button that closes it: label "Cancel" before anything is done, "Close" (the default) after it.',
    'DialogFooter is the footer on its own, for a window built some other way.',
  ],
  snippet:
    "<DialogWindow\n  title='Run Automatic Invoicing Now'\n  eyebrow={projectName}\n  errorText={errorText}\n  buttons={<DialogCloseButton onClick={onClose} />}\n  onClose={onClose}\n>\n  <p>The run is done.</p>\n</DialogWindow>",
  render: DialogWindowDemoComponent,
};
